
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import { learnStatus } from '../../utils/publish'
import DashboardHeader from './DashboardHeader.vue'
  @Component({ 
    name: 'DashboardStudent',
    components: { DashboardHeader } 
  })
  
export default class DashboardCourse extends Vue {

    tableData: any = []
    tableData1: any = []
    tableData2: any = []
    type: any = ''
    title = ''
    tableHeight: number = window.innerHeight - 200
    list = []
    list1 = []
    list3 = []
    list4 = []

    business_type = ''
    data_type = ''
    instrumentTypes = []
    teacherType = []
    campusType = []
    time: any = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30),new Date()]
    start_time =  1
    end_time = Date.parse(this.time[1])/1000
    loading = true

    getHeight() {
      window.onresize = () =>{
        this.tableHeight = window.innerHeight - 200
      }
    }
    getColor (type) {
      return learnStatus(type)
    }

    toStudentDetail(val) {
      let url = ''
      let key: string = ''
      let value: any = ''
      if (val.prop.includes('ages')) {
        key = 'ages'
        value = val.prop.replace('ages','')
      } else if (val.prop.includes('instrument_type_id')) {
        key = 'instrument_type_id'
        value = val.prop.replace('instrument_type_id','')
      } else if (val.prop.includes('course_type_id')) {
        key = 'course_type_id'
        value = val.prop.replace('course_type_id','')
      } else if (val.prop === 'dianping_total') {
        key = 'has_comment'
        value = 3
      } else if (val.prop === 'xinzeng_total' || val.prop === 'xiaohao_total'){
        key = ''
        value = ''
      } else if (val.prop === 'youxiao_total') {
        key = 'is_end'
        value = 0
      } else {
        key = ''
        value = ''
      }
      if(this.type == '1') {
        url = '/customer/student'
        if (val.prop === 'total' || val.prop === 'dianping_total' || val.prop === 'youxiao_total') {
          this.time = []
        }
      } else if (this.type == '3') {
        if (val.prop === 'total') {
          this.time = []
          url = '/customer/student'
        } else if (val.prop === 'xinzeng_total') {
          url = '/customer/student'
        } else {
          url = '/course/sign'
        }
      }
      if(url) {
        this.$router.push({ path: `${url}`, query: { from: 'student', key: key, value: value, campus: JSON.stringify(this.campusType),time: JSON.stringify(this.time),teacher: JSON.stringify(this.teacherType), instrument: JSON.stringify(this.instrumentTypes) } })
      }
    }

    async getInstrumentType(){ //乐器类型
      const res: any = await UserModule.InstrumentType()
      if(res.code === 200) {
        this.list3 = res.data.list
        this.gitCourseType()
      }
    }
    async gitCourseType() {  // 获取课程种类
      const res:any = await UserModule.courseType()
      if(res.code === 200) {
        this.list1 = res.data.list
        this.getDataType()
      }
    }

    async getStudent() {
      const res:any = await UserModule.dashboardStudent( {data_type: this.data_type, instrument_type: this.instrumentTypes, campus_id: this.campusType, teacher_id: this.teacherType,start_time: this.start_time, end_time: this.end_time } )
      if(res.code === 200) {
        const data = res.data

        if(this.type == 1) {
          this.tableData2 = data
          for (var i in data[0]) {
            if(i != 'total') {
              data[0][i] = data[0][i] + ' ('+ ((data[0][i]/data[0]['total'])*100).toFixed(2)+'%' +')'
            }
          }
          this.tableData = this.tableData2
        } else if (this.type == 2) {

          this.tableData = data
        } else if (this.type == 3) {
          this.tableData1 = data
          for(var k = 0; k < this.tableData1.length; k++){
            // 课程类型
            for(var j = 0; j < this.list1.length;j++){
              if(this.tableData1[k]['course_type_id'+ this.list1[j].id]) {
                this.tableData1[k]['course_type_id'+ this.list1[j].id] = this.tableData1[k]['course_type_id'+ this.list1[j].id] + '('+ (this.tableData1[k]['course_type_id'+ this.list1[j].id]/this.tableData1[k].total*100).toFixed(2)+'%' +')'
              }
            }
          }
          this.tableData = this.tableData1
        }
      }

    }

    getDataType() {
      this.type = this.$route.query.type
      if(this.type == 1) { // 学生总数
        this.title = '学生总数'
        const list = [{name: '数量',prop: 'total'}, {name:'已点评人数', prop: 'dianping_total'}, {name: '有效学生数量', prop: 'youxiao_total'}, {name: '新增学生数量', prop: 'xinzeng_total'}]
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list
        this.data_type = '1'
        this.getStudent()
      } else if (this.type == 2) {
        this.title = '剩余课时小于五次'
        this.list = [{name: '学员姓名',prop: 'student_name'},{name: '老师姓名',prop: 'teacher_name'},{name: '联系方式',prop: 'phone'},{name: '剩余课时数',prop: 'shengyukeshi'},{name: '购买套餐',prop: 'packet_name'}]
        this.data_type = '3'
        this.getStudent()
      } else if (this.type == 3) {
        this.title = '学员累计新增课时'
        const list = [{name: '数量',prop: 'total'}, {name: '新增课时',prop: 'xinzeng_total'}, {name: '消耗课时',prop: 'xiaohao_total'}]
        for (var i = 0; i < this.list1.length; i++) {
          list.push({name: this.list1[i].name,prop: 'course_type_id'+this.list1[i].id})
        }
        this.list = list
        this.data_type = '2'
        this.getStudent()
      }
    }

    getDataChange(val) {
      this.instrumentTypes = val.instrumentTypes
      this.teacherType = val.teacherType
      this.campusType = val.campusType
      this.time = val.time
      this.start_time = Date.parse(this.time[0])/1000
      this.end_time = Date.parse(this.time[1])/1000
      this.getInstrumentType()
    }

    mounted(){
      this.getHeight()
    }
  }
